import { PERFORM_LOGIN } from 'actions/logIn'

export default (state = null, action) => {
    switch (action.type) {
        case PERFORM_LOGIN:
            if (!!action.error) {
                return action.payload
            } else {
                return action.payload.data;
            }
    }

    return state;
}